<script>
  // # # # # # # # # # # # # #
  //
  //  MALWARE ENGINE
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  //   import { onMount } from "svelte";

  // *** COMPONENTS
  import MalwareBox from './MalwareBox.svelte'

  const malwareText =
    'What makes someone open or closed? People don´t have a lid or a bottle cap, so what makes them open or closed? Do you consider yourself open or closed? Is one better than the other? Are we always looking for the best? Are you always looking for the best? Are we always looking? Are we always? Ah! You don´t have any answer, all you want to say is ”yes I am open” but deep down you´re not sure if that´s the case. Sorry for putting you in this situation. But don´t worry, here is my corner. It´s really comfortable, I´ll share it with you!'

  // CONSTANTS
  const boxes = [
    {
      order: 0,
      text:
        "<div class='big'>Trying to expand</div> my vocabulary in an effort to dissolve me, but to expand my  world.",
    },
    {
      order: 1,
      text:
        "<div class='big'>And an ego</div> which is the letting yourself go.",
    },
    {
      order: 2,
      text:
        "<div class='big'>They never</div> needed me to disappear into I disappear into them",
    },
    {
      order: 3,
      text:
        "<div class='big'>All these things exist</div> but still I pine for finding them/it again, and again.",
    },
    {
      order: 4,
      text:
        'To circle back and return, doing it in a different order always. (I’m in a good place, some days) Because of it I’m not only myself. Sigh. tsk. pyhh, åhh.',
    },
    {
      order: 5,
      text: "<div class='big'>Do awkward-ness come from insecurity?</div>",
    },
    {
      order: 6,
      text: 'Is a security guard then ever awkward?',
    },
    {
      order: 7,
      text: 'What do I tell a young person with goosebumps?',
    },
    {
      order: 8,
      text:
        "You will grow out of it, feelings will not always be this vivid. But sometimes your goosebumps will become spikes, will become spears, will become something like an <span class='strike'>armor</span> weapon you can hide inside but still be fully visible in. Maybe the security guard can become your friend? But I don’t know.",
    },
    {
      order: 9,
      text:
        "<div class='big'>And in return</div> I will comfort my corner, listen to my corner, nod and understand when my corner talks, give my corner advice if it wants. Maybe we can shape each  other.",
    },
    {
      order: 10,
      text:
        'Maybe we can help each other: embrace surprises together, have tough conversations, go to therapy, give wardrobe advice, cuddle, do the dishes, read aloud for each other, suck on some stones together —and learn how to live.',
    },
    {
      order: 11,
      text:
        "<div class='big'>Sand in the bed that needs a sweep</div> before the night and eyelids that sweep the floor at dawn.",
    },
    {
      order: 12,
      text:
        "<div class='big'>My corner is fluid,</div> as in a substance that has no fixed shape and yields easily to external pressure,",
    },
    {
      order: 13,
      text:
        "<div class='big'>It is tempting to stay here</div> to watch firmness melt into something other. To watch the edges disappear.",
    },
  ]

  // *** STORES
  import { malwareActive } from '../stores.js'

  // VARIABLES
  let counter = 0
</script>

<style lang="scss">
  @import '../variables.scss';

  .container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: cennter;
    cursor: pointer;
  }
</style>

<!-- BOXES -->
<div
  class="container"
  on:click={(e) => {
    counter++
    if (counter > boxes.length - 1) malwareActive.set(false)
  }}>
  {#each boxes as box, i (box.text)}
    {#if box.order == counter}
      <MalwareBox text={box.text} />
    {/if}
  {/each}
</div>
